import React from 'react'
import PropTypes from 'prop-types'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import ListItemText, { listItemTextClasses } from '@mui/material/ListItemText'
import { Box, TableRow } from '@mui/material'
import HHDisplayMoney from '../../../common/HHDisplayMoney'

const LateFeeChargeTableRow = ({ summary, note, startDate, feeCharge, quantity, total }) => {
  const typographySx = {
    lineHeight: 'unset',
    verticalAlign: 'bottom',
  }
  return (
    <>
      <TableRow
        sx={{
          [`& .${tableCellClasses.root}`]: {
            pt: 0,
            pb: 0,
          },
          [`& .${tableCellClasses.root}.${tableCellClasses.paddingNone}`]: {
            pt: 0,
            pb: 0,
          },
          [`& .${listItemTextClasses.root}`]: {
            m: 0,
          },
        }}
      >
        <TableCell padding="none">
          <ListItemText
            primary={summary}
            secondary={<Box height="1rem">{note}</Box>}
            slotProps={{
              primary: {
                lineHeight: 'unset',
                color: 'textPrimary',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                gutterBottom: false,
              },

              secondary: {
                variant: 'body1',
              },
            }}
          />
        </TableCell>
        <TableCell padding="none">
          <ListItemText
            secondary={<Box height="1rem" />}
            primary={startDate}
            slotProps={{
              primary: { sx: typographySx, variant: 'body1' },

              secondary: {
                lineHeight: 'unset',
                color: 'textPrimary',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                gutterBottom: false,
              },
            }}
          />
        </TableCell>
        <TableCell padding="none">
          <ListItemText
            secondary={<Box height="1rem" />}
            primary={<HHDisplayMoney value={feeCharge} formatToDollars={false} />}
            slotProps={{
              primary: { sx: typographySx, variant: 'body1', color: 'textPrimary', textAlign: 'right' },

              secondary: {
                lineHeight: 'unset',
                color: 'textPrimary',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                gutterBottom: false,
              },
            }}
          />
        </TableCell>
        <TableCell padding="none">
          <ListItemText
            secondary={<Box height="1rem" />}
            primary={quantity > 0 && quantity}
            slotProps={{
              primary: { sx: typographySx, variant: 'body1', color: 'textPrimary', textAlign: 'right' },

              secondary: {
                lineHeight: 'unset',
                color: 'textPrimary',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                gutterBottom: false,
              },
            }}
          />
        </TableCell>
        <TableCell padding="none" align="right">
          <ListItemText
            secondary={<Box height="1rem" />}
            primary={<HHDisplayMoney value={total} formatToDollars={false} />}
            slotProps={{
              primary: { sx: typographySx, variant: 'body1', color: 'textPrimary' },

              secondary: {
                lineHeight: 'unset',
                color: 'textPrimary',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                gutterBottom: false,
              },
            }}
          />
        </TableCell>
      </TableRow>
    </>
  )
}

LateFeeChargeTableRow.propTypes = {
  summary: PropTypes.string,
  note: PropTypes.string,
  startDate: PropTypes.string,
  feeCharge: PropTypes.string,
  quantity: PropTypes.number,
  total: PropTypes.string,
}

export default LateFeeChargeTableRow
